export default "__VITE_ASSET__175bf87a__"